import { CONTENT_API, BLOG_API, PUSH_API } from '../config'
import axios from 'axios'

const pensamientos = axios.create({ baseURL: `${CONTENT_API}/pensamientos` })
const matutinas = axios.create({ baseURL: `${CONTENT_API}/matutinas` })
const programas = axios.create({ baseURL: `${CONTENT_API}/programas` })
const posts = axios.create({ baseURL: `${BLOG_API}/posts/` })
const tags = axios.create({ baseURL: `${BLOG_API}/tags/` })
const notificaciones = axios.create({ baseURL: `${PUSH_API}` })

const services = {
  $http: {
    get () {
      return {
        pensamientos,
        matutinas,
        programas,
        posts,
        tags,
        notificaciones
      }
    },
    post () {
      return {
        notificaciones
      }
    }
  }
}

export default (Vue) => {
  Object.defineProperties(Vue.prototype, services)
}
